import { ReactNode } from 'react';

interface DataSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

const DataSection = ({ title, children, className = '' }: DataSectionProps) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <span className='text-[13px] text-gray-700 dark:text-gray-300 pb-2'>
        {title}
      </span>
      {children}
    </div>
  );
};

export default DataSection;
